export function getRegionByDiario(idDiario) {
    var region_by_diario = {
        2: 279,
        3: 281,
        4: 279,
        5: 282,
        7: 274,
        8: 271,
        9: 280,
        10: 269,
        11: 274,
        12: 270,
        13: 282,
        14: 271,
        15: 279,
        16: 272,
        17: 274,
        18: 282,
        19: 271,
        20: 271,
        21: 271
    }
    return region_by_diario[idDiario]
}